import { useEffect } from 'react'

import { shallowEqual } from 'react-redux'

import { useGetAccountQuery } from 'store/account/accountApiWithQuery'
import { apiHeadersActions } from 'store/apiHeaders/apiHeadersSlice'
import { useGetSessionsQuery } from 'store/company/companyApiWithQuery'
import { State } from 'store/state'

import { useAppDispatch, useAppSelector } from '../store/hooks'

import { Roles } from './useAuthRoles'

export const useGetApiHeaderData = (isAuthenticated: boolean) => {
  const dispatch = useAppDispatch()
  const { companyId, accountId, sessionId, user } = useAppSelector(
    (state: State) => ({
      companyId: state.apiHeadersReducer.companyId,
      accountId: state.apiHeadersReducer.accountId,
      sessionId: state.apiHeadersReducer.sessionId,
      user: state.authReducer.user,
    }),
    shallowEqual
  )

  useGetAccountQuery(undefined, { skip: !isAuthenticated })

  useGetSessionsQuery(undefined, {
    skip: !isAuthenticated,
  })

  const isAdmin = user?.roles.includes(Roles.ADMIN)

  const companyIdFromUser = user?.companyId

  useEffect(() => {
    if (!isAdmin && companyIdFromUser) {
      dispatch(apiHeadersActions.setCompanyId(companyIdFromUser))
    }
  }, [dispatch, isAdmin, companyIdFromUser])

  return isAdmin || !!(companyId && accountId && sessionId)
}
